import Image from 'next/image'
import React, { useState } from 'react'

import { airline_logo_version } from '@/constants/icon'
import { trackAirlineLogoError } from '@/utils/sentry'

/* eslint-disable react/no-unused-prop-types */
type ImageBlockType = {
    path: string
    altText: string
    width: number
    height: number
    customClass?: string
    isMultiAirline?: boolean
    isCircleLogo?: boolean
    showBorder?: boolean
}
/* eslint-enable react/no-unused-prop-types */
const ImageBlock = (props: ImageBlockType) => {
    const { altText, width = 16, height = 16, customClass, isMultiAirline , isCircleLogo = false, showBorder = true } = props || {}
    let { path } = props || {}
    const [error, setError] = useState(false)

    // Store original path for error tracking before any modifications
    const originalPath = path

    if (!path) {
        path =  'https://static-assets-ct.flixcart.com/ct/assets/resources/images/logos/air-logos/DEFAULT_2x.png'
    }
    if (isMultiAirline) {
        path = 'https://static-assets-ct.flixcart.com/ct/assets/resources/images/logos/multiAirline.png'
    }

    if (error) {
        path = `https://static-assets-ct.flixcart.com/ct/assets/resources/images/logos/air-logos/DEFAULT_2x.png`
    }

    // Check if path already has version parameter to avoid duplication
    const hasVersion = path?.includes('?v=')
    const srcUrl = hasVersion ? path : `${path}?v=${airline_logo_version}`

    const handleError = () => {
        // Track error to Sentry before setting error state
        if (!error && originalPath) {
            // Check if originalPath already has version parameter to avoid duplication
            const originalHasVersion = originalPath?.includes('?v=')
            trackAirlineLogoError(
                altText || 'unknown',
                originalHasVersion ? originalPath : `${originalPath}?v=${airline_logo_version}`,
                'ImageBlock'
            )
        }
        setError(true)
    }

    return (
        <Image
            alt={altText}
            className={customClass ? customClass : 'br-8 o-hidden'}
            height={height}
            src={srcUrl}
            style={{
                border: showBorder ? '1px solid #EBEBEB' : undefined,
                borderRadius: isCircleLogo ? '50%' : '20%'
              }}
            width={width}
            onError={handleError}
        />
    )
}

export default ImageBlock
